import React from 'react';
import { Link } from 'react-router-dom';
import { Github, Twitter, MessageCircle } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-green-900/30 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img src="/logo.webp" alt="Swenzy" className="w-10 h-10 rounded-lg" />
              <span className="text-2xl font-bold text-green-400">Swenzy</span>
            </div>
            <p className="text-gray-400 mb-4">
              Hızlı, güvenilir ve profesyonel Discord botlarının tek adresi.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-green-400 transition-colors">
                <MessageCircle className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-green-400 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-green-400 transition-colors">
                <Github className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Hızlı Linkler</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-green-400 transition-colors">
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <a href="#packages" className="text-gray-400 hover:text-green-400 transition-colors">
                  Paketler
                </a>
              </li>
              <li>
                <a href="#bots" className="text-gray-400 hover:text-green-400 transition-colors">
                  Botlar
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-green-400 transition-colors">
                  Ek Hizmetler
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Destek</h3>
            <ul className="space-y-2">
              <li>
                <a href="#faq" className="text-gray-400 hover:text-green-400 transition-colors">
                  SSS
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-gray-400 hover:text-green-400 transition-colors">
                  Müşteri Yorumları
                </a>
              </li>
              <li>
                <Link to="/login" className="text-gray-400 hover:text-green-400 transition-colors">
                  Giriş Yap
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-gray-400 hover:text-green-400 transition-colors">
                  Kayıt Ol
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-green-900/30 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2024 Swenzy. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;